import Vue from 'vue';

import App from './App.vue';
// Vue Router
import router from '@/router';
// Vuex Store
import store from '@/store';
// Global Constants
import constants from '@/constants';

import '@/components/common-ui';

// ========================================
//
// Setup Add
//
// ========================================
// axios Add
import axios from "./setup/axios-setup";
// Multi Language Add
import { i18n } from './setup/i18n-setup';
// Apollo Add
import {apolloProvider} from './setup/apollo-setup';
// Form Validation Add
import '@/setup/vee-validate-setup';
// Global Components Add
import '@/setup/global-components-setup';
// Theme Add
import '@/setup/theme-setup';
// import store_ from './store/store'
import { setDebugStatus } from '@/utils/debugger';

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$constants = constants;
Vue.prototype.$env = process.env;
Vue.prototype.$debug = setDebugStatus();

// Theme Configurations
// import '../themeConfig.js'

// import Vuex from 'vuex'

Vue.config.productionTip = false;

const vm = new Vue({
  i18n,
  apolloProvider,
  router,
  store,
  render: h => h(App)
}).$mount('#app');

export default vm;


/* 
  For help debugging, don't remove
*/
if (process.env.VUE_APP_DEPLOYMENT_STAGE === "development"
  || process.env.VUE_APP_LOCAL_SERVER === "true") {
  console.log("DEBUG: Environment Variables", process.env) // eslint-disable-line no-console
}
